export const inverterInformation = [
  "Select",
  {
    brand: "DUNEXT",
    phase: "Single Phase",
    systemType: "Hybrid",
    inverterType: [
      {
        name: "DN1H-3KTL",
        value: 3,
        outPutPower: 3000,
        pvPower: 3600,
        efficiency: 97.4,
        maxInputVolatge: 600,
        startUpVoltage: 150,
        operatingVoltage: 550,
        mppt: 13.5,
        mscc: 17,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 13,
        dataSheet1: "../images/Inverter/Dunext/3-6-1.jpg",
        dataSheet2: "../images/Inverter/Dunext/3-6-2.jpg",
      },
      {
        name: "DN1H-3.68KTL",
        value: 3.68,
        outPutPower: 3680,
        pvPower: 4416,
        efficiency: 97.5,
        maxInputVolatge: 600,
        startUpVoltage: 150,
        operatingVoltage: 550,
        mppt: 13.5,
        mscc: 17,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 16,
        dataSheet1: "../images/Inverter/Dunext/3-6-1.jpg",
        dataSheet2: "../images/Inverter/Dunext/3-6-2.jpg",
      },
      {
        name: "DN1H-5KTL",
        value: 5,
        outPutPower: 5000,
        pvPower: 6000,
        efficiency: 97.4,
        maxInputVolatge: 600,
        startUpVoltage: 150,
        operatingVoltage: 550,
        mppt: 13.5,
        mscc: 17,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 21.7,
        dataSheet1: "../images/Inverter/Dunext/3-6-1.jpg",
        dataSheet2: "../images/Inverter/Dunext/3-6-2.jpg",
      },
      {
        name: "DN1H-6KTL",
        value: 6,
        outPutPower: 6000,
        pvPower: 7200,
        efficiency: 97.5,
        maxInputVolatge: 600,
        startUpVoltage: 150,
        operatingVoltage: 550,
        mppt: 13.5,
        mscc: 17,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 26.1,
        dataSheet1: "../images/Inverter/Dunext/3-6-1.jpg",
        dataSheet2: "../images/Inverter/Dunext/3-6-2.jpg",
      },
    ],
    powerSensor: ["No Power Sensor"],

    communicationDevice: [
      "No Communication Device",
      "RS485",
      "WIFI",
      "Ethernet",
    ],
  },
  {
    brand: "DUNEXT",
    phase: "Single Phase",
    systemType: "On Grid",
    inverterType: [
      {
        name: "DN1-3.68KTL",
        value: 3.68,
        outPutPower: 3680,
        pvPower: 4416,
        efficiency: 97.9,
        maxInputVolatge: 600,
        startUpVoltage: 100,
        operatingVoltage: 550,
        mppt: 16,
        mscc: 20,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 16,
        dataSheet1: "../images/Inverter/Dunext/3.68-6-1.jpg",
        dataSheet2: "../images/Inverter/Dunext/3.68-6-2.jpg",
      },
      {
        name: "DN1-4KTL",
        value: 4,
        outPutPower: 4000,
        pvPower: 4800,
        efficiency: 97.9,
        maxInputVolatge: 600,
        startUpVoltage: 100,
        operatingVoltage: 550,
        mppt: 16,
        mscc: 20,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 20,
        dataSheet1: "../images/Inverter/Dunext/3.68-6-1.jpg",
        dataSheet2: "../images/Inverter/Dunext/3.68-6-2.jpg",
      },
      {
        name: "DN1-5KTL",
        value: 5,
        outPutPower: 5000,
        pvPower: 6000,
        efficiency: 97.9,
        maxInputVolatge: 600,
        startUpVoltage: 100,
        operatingVoltage: 550,
        mppt: 16,
        mscc: 20,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 25,
        dataSheet1: "../images/Inverter/Dunext/3.68-6-1.jpg",
        dataSheet2: "../images/Inverter/Dunext/3.68-6-2.jpg",
      },
      {
        name: "DN1-6KTL",
        value: 6,
        outPutPower: 6000,
        pvPower: 7200,
        efficiency: 97.9,
        maxInputVolatge: 600,
        startUpVoltage: 100,
        operatingVoltage: 550,
        mppt: 16,
        mscc: 20,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 27.3,
        dataSheet1: "../images/Inverter/Dunext/3.68-6-1.jpg",
        dataSheet2: "../images/Inverter/Dunext/3.68-6-2.jpg",
      },
      {
        name: "DN1-8KTL",
        value: 8,
        outPutPower: 8000,
        pvPower: 9600,
        efficiency: 98.1,
        maxInputVolatge: 600,
        startUpVoltage: 100,
        operatingVoltage: 550,
        mppt: 32,
        mscc: 40,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 40,
        dataSheet1: "../images/Inverter/Dunext/8-10.5-1.jpg",
        dataSheet2: "../images/Inverter/Dunext/8-10.5-2.jpg",
      },
      {
        name: "DN1-10KTL",
        value: 10,
        outPutPower: 10000,
        pvPower: 12000,
        efficiency: 98.1,
        maxInputVolatge: 600,
        startUpVoltage: 100,
        operatingVoltage: 550,
        mppt: 32,
        mscc: 40,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 45.5,
        dataSheet1: "../images/Inverter/Dunext/8-10.5-1.jpg",
        dataSheet2: "../images/Inverter/Dunext/8-10.5-2.jpg",
      },
      {
        name: "DN1-10.5KTL",
        value: 10.5,
        outPutPower: 10500,
        pvPower: 12600,
        efficiency: 98.1,
        maxInputVolatge: 600,
        startUpVoltage: 100,
        operatingVoltage: 550,
        mppt: 32,
        mscc: 40,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 45.4,
        dataSheet1: "../images/Inverter/Dunext/8-10.5-1.jpg",
        dataSheet2: "../images/Inverter/Dunext/8-10.5-2.jpg",
      },
    ],
    powerSensor: ["No Power Sensor"],
    communicationDevice: [
      "No Communication Device",
      "RS485",
      "WIFI",
      "Ethernet",
    ],
  },
  {
    brand: "DUNEXT",
    phase: "Three Phase",
    systemType: "Hybrid",
    inverterType: [
      {
        name: "DN3H-5KTL",
        value: 5,
        outPutPower: 5000,
        pvPower: 6000,
        efficiency: 98,
        maxInputVolatge: 1000,
        startUpVoltage: 160,
        operatingVoltage: 950,
        mppt: 18,
        mscc: 23,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 7.6,
        dataSheet1: "../images/Inverter/Dunext/5-10-1.jpg",
        dataSheet2: "../images/Inverter/Dunext/5-10-2.jpg",
      },
      {
        name: "DN3H-6KTL",
        value: 6,
        outPutPower: 6000,
        pvPower: 7200,
        efficiency: 98,
        maxInputVolatge: 1000,
        startUpVoltage: 160,
        operatingVoltage: 950,
        mppt: 18,
        mscc: 23,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 9.1,
        dataSheet1: "../images/Inverter/Dunext/5-10-1.jpg",
        dataSheet2: "../images/Inverter/Dunext/5-10-2.jpg",
      },
      {
        name: "DN3H-8KTL",
        value: 8,
        outPutPower: 8000,
        pvPower: 9600,
        efficiency: 98,
        maxInputVolatge: 1000,
        startUpVoltage: 160,
        operatingVoltage: 950,
        mppt: 18,
        mscc: 23,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 12.2,
        dataSheet1: "../images/Inverter/Dunext/5-10-1.jpg",
        dataSheet2: "../images/Inverter/Dunext/5-10-2.jpg",
      },
      {
        name: "DN3H-10KTL-A",
        value: 10,
        outPutPower: 10000,
        pvPower: 12000,
        efficiency: 98,
        maxInputVolatge: 1000,
        startUpVoltage: 160,
        operatingVoltage: 950,
        mppt: 18,
        mscc: 23,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 14.4,
        dataSheet1: "../images/Inverter/Dunext/5-10-1.jpg",
        dataSheet2: "../images/Inverter/Dunext/5-10-2.jpg",
      },
      {
        name: "DN3H-10KTL",
        value: 10,
        outPutPower: 10000,
        pvPower: 12000,
        efficiency: 98,
        maxInputVolatge: 1000,
        startUpVoltage: 160,
        operatingVoltage: 950,
        mppt: 18,
        mscc: 23,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 15.2,
        dataSheet1: "../images/Inverter/Dunext/5-10-1.jpg",
        dataSheet2: "../images/Inverter/Dunext/5-10-2.jpg",
      },
    ],
    powerSensor: ["No Power Sensor"],
    communicationDevice: [
      "No Communication Device",
      "RS485",
      "WIFI",
      "Ethernet",
    ],
  },
  {
    brand: "DUNEXT",
    phase: "Three Phase",
    systemType: "On Grid",
    inverterType: [
      {
        name: "DN3-4KTL",
        value: 4,
        outPutPower: 4000,
        pvPower: 4800,
        efficiency: 98.4,
        maxInputVolatge: 1100,
        startUpVoltage: 160,
        operatingVoltage: 1000,
        mppt: 16,
        mscc: 20,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 6.7,
        dataSheet1: "../images/Inverter/Dunext/4-12-1.jpg",
        dataSheet2: "../images/Inverter/Dunext/4-12-2.jpg",
      },
      {
        name: "DN3-5KTL",
        value: 5,
        outPutPower: 5000,
        pvPower: 6000,
        efficiency: 98.4,
        maxInputVolatge: 1100,
        startUpVoltage: 160,
        operatingVoltage: 1000,
        mppt: 16,
        mscc: 20,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 8.4,
        dataSheet1: "../images/Inverter/Dunext/4-12-1.jpg",
        dataSheet2: "../images/Inverter/Dunext/4-12-2.jpg",
      },
      {
        name: "DN3-6KTL",
        value: 6,
        outPutPower: 6000,
        pvPower: 7100,
        efficiency: 98.5,
        maxInputVolatge: 1100,
        startUpVoltage: 160,
        operatingVoltage: 1000,
        mppt: 16,
        mscc: 20,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 10,
        dataSheet1: "../images/Inverter/Dunext/4-12-1.jpg",
        dataSheet2: "../images/Inverter/Dunext/4-12-2.jpg",
      },
      {
        name: "DN3-8KTL",
        value: 8,
        outPutPower: 8000,
        pvPower: 9600,
        efficiency: 98.5,
        maxInputVolatge: 1100,
        startUpVoltage: 160,
        operatingVoltage: 1000,
        mppt: 16,
        mscc: 20,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 13.4,
        dataSheet1: "../images/Inverter/Dunext/4-12-1.jpg",
        dataSheet2: "../images/Inverter/Dunext/4-12-2.jpg",
      },
      {
        name: "DN3-10KTL-A",
        value: 10,
        outPutPower: 10000,
        pvPower: 12000,
        efficiency: 98.5,
        maxInputVolatge: 1100,
        startUpVoltage: 160,
        operatingVoltage: 1000,
        mppt: 16,
        mscc: 20,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 15.2,
        dataSheet1: "../images/Inverter/Dunext/4-12-1.jpg",
        dataSheet2: "../images/Inverter/Dunext/4-12-2.jpg",
      },
      {
        name: "DN3-10KTL",
        value: 10,
        outPutPower: 10000,
        pvPower: 12000,
        efficiency: 98.5,
        maxInputVolatge: 1100,
        startUpVoltage: 160,
        operatingVoltage: 1000,
        mppt: 16,
        mscc: 20,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 16.7,
        dataSheet1: "../images/Inverter/Dunext/4-12-1.jpg",
        dataSheet2: "../images/Inverter/Dunext/4-12-2.jpg",
      },
      {
        name: "DN3-12KTL",
        value: 12,
        outPutPower: 12000,
        pvPower: 14400,
        efficiency: 98.5,
        maxInputVolatge: 1100,
        startUpVoltage: 160,
        operatingVoltage: 1000,
        mppt: 16,
        mscc: 20,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 20,
        dataSheet1: "../images/Inverter/Dunext/4-12-1.jpg",
        dataSheet2: "../images/Inverter/Dunext/4-12-2.jpg",
      },
      {
        name: "DN3-15KTL",
        value: 15,
        outPutPower: 15000,
        pvPower: 18000,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 200,
        operatingVoltage: 1000,
        mppt: 40,
        mscc: 50,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 25,
        dataSheet1: "../images/Inverter/Dunext/15-25-1.jpg",
        dataSheet2: "../images/Inverter/Dunext/15-25-2.jpg",
      },
      {
        name: "DN3-17KTL",
        value: 17,
        outPutPower: 17000,
        pvPower: 20400,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 200,
        operatingVoltage: 1000,
        mppt: 40,
        mscc: 50,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 28.3,
        dataSheet1: "../images/Inverter/Dunext/15-25-1.jpg",
        dataSheet2: "../images/Inverter/Dunext/15-25-2.jpg",
      },
      {
        name: "DN3-20KTL",
        value: 20,
        outPutPower: 20000,
        pvPower: 24000,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 200,
        operatingVoltage: 1000,
        mppt: 40,
        mscc: 50,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 33.4,
        dataSheet1: "../images/Inverter/Dunext/15-25-1.jpg",
        dataSheet2: "../images/Inverter/Dunext/15-25-2.jpg",
      },
      {
        name: "DN3-25KTL",
        value: 25,
        outPutPower: 25000,
        pvPower: 30000,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 200,
        operatingVoltage: 1000,
        mppt: 40,
        mscc: 50,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 41.7,
        dataSheet1: "../images/Inverter/Dunext/15-25-1.jpg",
        dataSheet2: "../images/Inverter/Dunext/15-25-2.jpg",
      },
      {
        name: "DN3-30KTL",
        value: 30,
        outPutPower: 30000,
        pvPower: 36000,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 200,
        operatingVoltage: 1000,
        mppt: 40,
        mscc: 50,
        noOfMPPT: 3,
        noOfStrings: 6,
        acCurrent: 50,
        dataSheet1: "../images/Inverter/Dunext/30-50-1.jpg",
        dataSheet2: "../images/Inverter/Dunext/30-50-2.jpg",
      },
      {
        name: "DN3-36KTL",
        value: 36,
        outPutPower: 36000,
        pvPower: 43200,
        efficiency: 98.7,
        maxInputVolatge: 1100,
        startUpVoltage: 200,
        operatingVoltage: 1000,
        mppt: 40,
        mscc: 50,
        noOfMPPT: 3,
        noOfStrings: 6,
        acCurrent: 60,
        dataSheet1: "../images/Inverter/Dunext/30-50-1.jpg",
        dataSheet2: "../images/Inverter/Dunext/30-50-2.jpg",
      },
      {
        name: "DN3-40KTL",
        value: 40,
        outPutPower: 40000,
        pvPower: 48000,
        efficiency: 98.8,
        maxInputVolatge: 1100,
        startUpVoltage: 200,
        operatingVoltage: 1000,
        mppt: 40,
        mscc: 50,
        noOfMPPT: 4,
        noOfStrings: 8,
        acCurrent: 66.6,
        dataSheet1: "../images/Inverter/Dunext/30-50-1.jpg",
        dataSheet2: "../images/Inverter/Dunext/30-50-2.jpg",
      },
      {
        name: "DN3-50KTL",
        value: 50,
        outPutPower: 50000,
        pvPower: 60000,
        efficiency: 98.8,
        maxInputVolatge: 1100,
        startUpVoltage: 200,
        operatingVoltage: 1000,
        mppt: 40,
        mscc: 50,
        noOfMPPT: 4,
        noOfStrings: 8,
        acCurrent: 83.3,
        dataSheet1: "../images/Inverter/Dunext/30-50-1.jpg",
        dataSheet2: "../images/Inverter/Dunext/30-50-2.jpg",
      },
    ],
    powerSensor: ["No Power Sensor"],
    communicationDevice: [
      "No Communication Device",
      "RS485",
      "WIFI",
      "Ethernet",
    ],
  },

  {
    brand: "HUAWEI",
    phase: "Three Phase",
    systemType: "On Grid",
    inverterType: [
      {
        name: "SUN2000-5kTL-M1",
        value: 5,
        outPutPower: 5000,
        pvPower: 6000,
        efficiency: 98.4,
        maxInputVolatge: 1100,
        startUpVoltage: 200,
        operatingVoltage: 980,
        mppt: 11,
        mscc: 15,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 15,
        dataSheet1: "../images/Inverter/Huawei/5-10-1.jpg",
        dataSheet2: "../images/Inverter/Huawei/5-10-2.jpg",
      },
      {
        name: "SUN2000-10kTL-M1",
        value: 10,
        outPutPower: 10000,
        pvPower: 12000,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 200,
        operatingVoltage: 980,
        mppt: 11,
        mscc: 15,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 15,
        dataSheet1: "../images/Inverter/Huawei/5-10-1.jpg",
        dataSheet2: "../images/Inverter/Huawei/5-10-2.jpg",
      },
      {
        name: "SUN2000-12kTL-M5",
        value: 12,
        outPutPower: 12000,
        pvPower: 14400,
        efficiency: 98.4,
        maxInputVolatge: 1100,
        startUpVoltage: 200,
        operatingVoltage: 980,
        mppt: 30,
        mscc: 40,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 18.2,
        dataSheet1: "../images/Inverter/Huawei/12-25-1.jpg",
        dataSheet2: "../images/Inverter/Huawei/12-25-2.jpg",
      },
      {
        name: "SUN2000-15kTL-M5",
        value: 15,
        outPutPower: 15000,
        pvPower: 18000,
        efficiency: 98.4,
        maxInputVolatge: 1100,
        startUpVoltage: 200,
        operatingVoltage: 980,
        mppt: 30,
        mscc: 40,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 25.2,
        dataSheet1: "../images/Inverter/Huawei/12-25-1.jpg",
        dataSheet2: "../images/Inverter/Huawei/12-25-2.jpg",
      },
      {
        name: "SUN2000-17kTL-M5",
        value: 17,
        outPutPower: 17000,
        pvPower: 20400,
        efficiency: 98.4,
        maxInputVolatge: 1100,
        startUpVoltage: 200,
        operatingVoltage: 980,
        mppt: 30,
        mscc: 40,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 28.6,
        dataSheet1: "../images/Inverter/Huawei/12-25-1.jpg",
        dataSheet2: "../images/Inverter/Huawei/12-25-2.jpg",
      },
      {
        name: "SUN2000-20kTL-M5",
        value: 20,
        outPutPower: 20000,
        pvPower: 24000,
        efficiency: 98.4,
        maxInputVolatge: 1100,
        startUpVoltage: 200,
        operatingVoltage: 980,
        mppt: 30,
        mscc: 40,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 33.6,
        dataSheet1: "../images/Inverter/Huawei/12-25-1.jpg",
        dataSheet2: "../images/Inverter/Huawei/12-25-2.jpg",
      },
      {
        name: "SUN2000-25kTL-M5",
        value: 25,
        outPutPower: 25000,
        pvPower: 30000,
        efficiency: 98.4,
        maxInputVolatge: 1100,
        startUpVoltage: 200,
        operatingVoltage: 980,
        mppt: 30,
        mscc: 40,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 42,
        dataSheet1: "../images/Inverter/Huawei/12-25-1.jpg",
        dataSheet2: "../images/Inverter/Huawei/12-25-2.jpg",
      },
      {
        name: "SUN2000-30kTL-M3",
        value: 30,
        outPutPower: 30000,
        pvPower: 36000,
        efficiency: 98.7,
        maxInputVolatge: 1100,
        startUpVoltage: 200,
        operatingVoltage: 1000,
        mppt: 26,
        mscc: 40,
        noOfMPPT: 4,
        noOfStrings: 8,
        acCurrent: 47.9,
        dataSheet1: "../images/Inverter/Huawei/30-40-1.jpg",
        dataSheet2: "../images/Inverter/Huawei/30-40-2.jpg",
      },
      {
        name: "SUN2000-36kTL-M3",
        value: 36,
        outPutPower: 36000,
        pvPower: 43200,
        efficiency: 98.7,
        maxInputVolatge: 1100,
        startUpVoltage: 200,
        operatingVoltage: 1000,
        mppt: 26,
        mscc: 40,
        noOfMPPT: 4,
        noOfStrings: 8,
        acCurrent: 58,
        dataSheet1: "../images/Inverter/Huawei/30-40-1.jpg",
        dataSheet2: "../images/Inverter/Huawei/30-40-2.jpg",
      },
      {
        name: "SUN2000-40kTL-M3",
        value: 40,
        outPutPower: 40000,
        pvPower: 48000,
        efficiency: 98.7,
        maxInputVolatge: 1100,
        startUpVoltage: 200,
        operatingVoltage: 1000,
        mppt: 26,
        mscc: 40,
        noOfMPPT: 4,
        noOfStrings: 8,
        acCurrent: 63.8,
        dataSheet1: "../images/Inverter/Huawei/30-40-1.jpg",
        dataSheet2: "../images/Inverter/Huawei/30-40-2.jpg",
      },
      {
        name: "SUN2000-50kTL-M3",
        value: 50,
        outPutPower: 50000,
        pvPower: 60000,
        efficiency: 98.5,
        maxInputVolatge: 1100,
        startUpVoltage: 200,
        operatingVoltage: 1000,
        mppt: 20,
        mscc: 40,
        noOfMPPT: 4,
        noOfStrings: 8,
        acCurrent: 79.8,
        dataSheet1: "../images/Inverter/Huawei/50-1.jpg",
        dataSheet2: "../images/Inverter/Huawei/50-2.jpg",
      },
      {
        name: "SUN2000-100kTL-M2",
        value: 100,
        outPutPower: 100000,
        pvPower: 120000,
        efficiency: 98.8,
        maxInputVolatge: 1100,
        startUpVoltage: 200,
        operatingVoltage: 1000,
        mppt: 26,
        mscc: 40,
        noOfMPPT: 10,
        noOfStrings: 20,
        acCurrent: 160.4,
        dataSheet1: "../images/Inverter/Huawei/50-1.jpg",
        dataSheet2: "../images/Inverter/Huawei/50-2.jpg",
      },
      {
        name: "SUN2000-115kTL-M2",
        value: 115,
        outPutPower: 115000,
        pvPower: 138000,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 200,
        operatingVoltage: 1000,
        mppt: 30,
        mscc: 40,
        noOfMPPT: 10,
        noOfStrings: 20,
        acCurrent: 182.3,
        dataSheet1: "../images/Inverter/Huawei/115-1.jpg",
        dataSheet2: "../images/Inverter/Huawei/115-2.jpg",
      },
      {
        name: "SUN2000-150kTL-MG0",
        value: 150,
        outPutPower: 150000,
        pvPower: 180000,
        efficiency: 98.4,
        maxInputVolatge: 1100,
        startUpVoltage: 200,
        operatingVoltage: 1000,
        mppt: 48,
        mscc: 66,
        noOfMPPT: 7,
        noOfStrings: 21,
        acCurrent: 253.2,
        dataSheet1: "../images/Inverter/Huawei/150-1.jpg",
        dataSheet2: "../images/Inverter/Huawei/150-2.jpg",
      },
      {
        name: "SUN2000-330KTL-H1",
        value: 330,
        outPutPower: 330000,
        pvPower: 396000,
        efficiency: 98.8,
        maxInputVolatge: 1500,
        startUpVoltage: 550,
        operatingVoltage: 1500,
        mppt: 28,
        mscc: 115,
        noOfMPPT: 6,
        noOfStrings: 28,
        acCurrent: 238.2,
        dataSheet1: "../images/Inverter/Huawei/330-1.png",
        dataSheet2: "../images/Inverter/Huawei/330-2.png",
      },
    ],
    powerSensor: [
      "No Power Sensor",
      "Chint DTSU666-H",
      "Chint DTSU666-H 250A/50mA",
      "Chint DTSU666-HW/YDS60-80",
    ],
    communicationDevice: [
      "No Communication Device",
      "Smart Dongle-4G",
      "SmartLogger3000A",
      "SmartACU2000D",
    ],
  },
  {
    brand: "SUNGROW",
    phase: "Three Phase",
    systemType: "On Grid",
    inverterType: [
      {
        name: "SG 5.0 RT",
        value: 5,
        outPutPower: 5000,
        pvPower: 6000,
        efficiency: 98.4,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 1000,
        mppt: 12.5,
        mscc: 16,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 8.3,
        dataSheet1: "../images/Inverter/SunGrow/5-12RT1.png",
        dataSheet2: "../images/Inverter/SunGrow/5-12RT2.png",
      },
      {
        name: "SG 6.0 RT",
        value: 6,
        outPutPower: 6000,
        pvPower: 7200,
        efficiency: 98.4,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 1000,
        mppt: 12.5,
        mscc: 16,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 10,
        dataSheet1: "../images/Inverter/SunGrow/5-12RT1.png",
        dataSheet2: "../images/Inverter/SunGrow/5-12RT2.png",
      },
      {
        name: "SG 7.0 RT",
        value: 7,
        outPutPower: 7000,
        pvPower: 8400,
        efficiency: 98.4,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 1000,
        mppt: 25,
        mscc: 32,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 11.7,
        dataSheet1: "../images/Inverter/SunGrow/5-12RT1.png",
        dataSheet2: "../images/Inverter/SunGrow/5-12RT2.png",
      },
      {
        name: "SG 8.0 RT",
        value: 8,
        outPutPower: 8000,
        pvPower: 9600,
        efficiency: 98.5,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 1000,
        mppt: 25,
        mscc: 32,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 13.3,
        dataSheet1: "../images/Inverter/SunGrow/5-12RT1.png",
        dataSheet2: "../images/Inverter/SunGrow/5-12RT2.png",
      },
      {
        name: "SG 10 RT",
        value: 10,
        outPutPower: 10000,
        pvPower: 12000,
        efficiency: 98.5,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 1000,
        mppt: 25,
        mscc: 32,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 16.7,
        dataSheet1: "../images/Inverter/SunGrow/5-12RT1.png",
        dataSheet2: "../images/Inverter/SunGrow/5-12RT2.png",
      },
      {
        name: "SG 12 RT",
        value: 12,
        outPutPower: 12000,
        pvPower: 14400,
        efficiency: 98.5,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 1000,
        mppt: 25,
        mscc: 32,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 20,
        dataSheet1: "../images/Inverter/SunGrow/5-12RT1.png",
        dataSheet2: "../images/Inverter/SunGrow/5-12RT2.png",
      },
      {
        name: "SG 15 RT",
        value: 15,
        outPutPower: 15000,
        pvPower: 18000,
        efficiency: 98.5,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 1000,
        mppt: 25,
        mscc: 31,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 25,
        dataSheet1: "../images/Inverter/SunGrow/15-20RT1.png",
        dataSheet2: "../images/Inverter/SunGrow/15-20RT2.png",
      },
      {
        name: "SG 17 RT",
        value: 17,
        outPutPower: 17000,
        pvPower: 20400,
        efficiency: 98.5,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 1000,
        mppt: 25,
        mscc: 31,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 28.3,
        dataSheet1: "../images/Inverter/SunGrow/15-20RT1.png",
        dataSheet2: "../images/Inverter/SunGrow/15-20RT2.png",
      },
      {
        name: "SG 20 RT",
        value: 20,
        outPutPower: 20000,
        pvPower: 24000,
        efficiency: 98.5,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 1000,
        mppt: 25,
        mscc: 31,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 31.9,
        dataSheet1: "../images/Inverter/SunGrow/15-20RT1.png",
        dataSheet2: "../images/Inverter/SunGrow/15-20RT2.png",
      },
      {
        name: "SG 30 CX-Premium",
        value: 30,
        outPutPower: 29900,
        pvPower: 35880,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 250,
        operatingVoltage: 1000,
        mppt: 26,
        mscc: 40,
        noOfMPPT: 3,
        noOfStrings: 6,
        acCurrent: 48.15,
        dataSheet1: "../images/Inverter/SunGrow/30XPremium1.png",
        dataSheet2: "../images/Inverter/SunGrow/30XPremium2.png",
      },
      {
        name: "SG 33 CX",
        value: 33,
        outPutPower: 33000,
        pvPower: 39600,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 250,
        operatingVoltage: 1000,
        mppt: 26,
        mscc: 40,
        noOfMPPT: 3,
        noOfStrings: 6,
        acCurrent: 55.2,
        dataSheet1: "../images/Inverter/SunGrow/30-50CX1.png",
        dataSheet2: "../images/Inverter/SunGrow/30-50CX2.png",
      },
      {
        name: "SG 40 CX",
        value: 40,
        outPutPower: 40000,
        pvPower: 48000,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 250,
        operatingVoltage: 1000,
        mppt: 26,
        mscc: 40,
        noOfMPPT: 4,
        noOfStrings: 8,
        acCurrent: 66.9,
        dataSheet1: "../images/Inverter/SunGrow/30-50CX1.png",
        dataSheet2: "../images/Inverter/SunGrow/30-50CX2.png",
      },
      {
        name: "SG 50 CX",
        value: 50,
        outPutPower: 50000,
        pvPower: 60000,
        efficiency: 98.7,
        maxInputVolatge: 1100,
        startUpVoltage: 250,
        operatingVoltage: 1000,
        mppt: 26,
        mscc: 40,
        noOfMPPT: 5,
        noOfStrings: 10,
        acCurrent: 83.6,
        dataSheet1: "../images/Inverter/SunGrow/30-50CX1.png",
        dataSheet2: "../images/Inverter/SunGrow/30-50CX2.png",
      },
      {
        name: "SG 33 CX(new)",
        value: 33,
        outPutPower: 33000,
        pvPower: 39600,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 250,
        operatingVoltage: 1000,
        mppt: 26,
        mscc: 40,
        noOfMPPT: 3,
        noOfStrings: 6,
        acCurrent: 55.2,
        dataSheet1: "../images/Inverter/SunGrow/33-50CXNew1.jpg",
        dataSheet2: "../images/Inverter/SunGrow/33-50CXNew2.jpg",
      },
      {
        name: "SG 40 CX(new)",
        value: 40,
        outPutPower: 40000,
        pvPower: 48000,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 250,
        operatingVoltage: 1000,
        mppt: 26,
        mscc: 40,
        noOfMPPT: 4,
        noOfStrings: 8,
        acCurrent: 66.9,
        dataSheet1: "../images/Inverter/SunGrow/33-50CXNew1.jpg",
        dataSheet2: "../images/Inverter/SunGrow/33-50CXNew2.jpg",
      },
      {
        name: "SG 50 CX(new)",
        value: 50,
        outPutPower: 50000,
        pvPower: 60000,
        efficiency: 98.7,
        maxInputVolatge: 1100,
        startUpVoltage: 250,
        operatingVoltage: 1000,
        mppt: 26,
        mscc: 40,
        noOfMPPT: 5,
        noOfStrings: 10,
        acCurrent: 83.6,
        dataSheet1: "../images/Inverter/SunGrow/33-50CXNew1.jpg",
        dataSheet2: "../images/Inverter/SunGrow/33-50CXNew2.jpg",
      },
      {
        name: "SG 110 CX",
        value: 110,
        outPutPower: 110000,
        pvPower: 132000,
        efficiency: 98.7,
        maxInputVolatge: 1100,
        startUpVoltage: 250,
        operatingVoltage: 1000,
        mppt: 26,
        mscc: 40,
        noOfMPPT: 9,
        noOfStrings: 18,
        acCurrent: 158.8,
        dataSheet1: "../images/Inverter/SunGrow/110CX1.png",
        dataSheet2: "../images/Inverter/SunGrow/110CX2.png",
      },
    ],
    powerSensor: ["No Power Sensor", "CHINT DTSU666-H"],
    communicationDevice: [
      "No Communication Device",
      "EyesM4",
      "WiNet-S",
      "Logger1000",
    ],
  },

  {
    brand: "SINENG",
    phase: "Three Phase",
    systemType: "On Grid",
    inverterType: [
      {
        name: "SN10PT",
        value: 10,
        outPutPower: 10000,
        pvPower: 12000,
        efficiency: 98.4,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 1000,
        mppt: 16,
        mscc: 25,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 15.9,
        dataSheet1: "../images/Inverter/Sineng/10-12-1.jpg",
        dataSheet2: "../images/Inverter/Sineng/10-12-2.jpg",
      },
      {
        name: "SN12PT",
        value: 12,
        outPutPower: 12000,
        pvPower: 14400,
        efficiency: 98.5,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 1000,
        mppt: 16,
        mscc: 25,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 19.1,
        dataSheet1: "../images/Inverter/Sineng/10-12-1.jpg",
        dataSheet2: "../images/Inverter/Sineng/10-12-2.jpg",
      },
      {
        name: "SN12PT-X",
        value: 12,
        outPutPower: 12000,
        pvPower: 14400,
        efficiency: 98.5,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 1000,
        mppt: 32,
        mscc: 50,
        noOfMPPT: 2,
        noOfStrings: 3,
        acCurrent: 19.1,
        dataSheet1: "../images/Inverter/Sineng/12-25-1.jpg",
        dataSheet2: "../images/Inverter/Sineng/12-25-2.jpg",
      },
      {
        name: "SN15PT",
        value: 15,
        outPutPower: 15000,
        pvPower: 18000,
        efficiency: 98.5,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 1000,
        mppt: 32,
        mscc: 50,
        noOfMPPT: 2,
        noOfStrings: 3,
        acCurrent: 23.9,
        dataSheet1: "../images/Inverter/Sineng/12-25-1.jpg",
        dataSheet2: "../images/Inverter/Sineng/12-25-2.jpg",
      },
      {
        name: "SN20PT",
        value: 20,
        outPutPower: 20000,
        pvPower: 24000,
        efficiency: 98.5,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 1000,
        mppt: 32,
        mscc: 50,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 31.9,
        dataSheet1: "../images/Inverter/Sineng/12-25-1.jpg",
        dataSheet2: "../images/Inverter/Sineng/12-25-2.jpg",
      },
      {
        name: "SN25PT-X",
        value: 25,
        outPutPower: 25000,
        pvPower: 30000,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 1000,
        mppt: 32,
        mscc: 50,
        noOfMPPT: 3,
        noOfStrings: 6,
        acCurrent: 39.9,
        dataSheet1: "../images/Inverter/Sineng/25-1.jpg",
        dataSheet2: "../images/Inverter/Sineng/25-2.jpg",
      },
      {
        name: "SN110PT",
        value: 110,
        outPutPower: 110000,
        pvPower: 132000,
        efficiency: 99,
        maxInputVolatge: 1100,
        startUpVoltage: 250,
        operatingVoltage: 1000,
        mppt: 64,
        mscc: 100,
        noOfMPPT: 5,
        noOfStrings: 20,
        acCurrent: 175.4,
        dataSheet1: "../images/Inverter/Sineng/110-125-1.jpg",
        dataSheet2: "../images/Inverter/Sineng/110-125-2.jpg",
      },
      {
        name: "SN125PT",
        value: 125,
        outPutPower: 125000,
        pvPower: 150000,
        efficiency: 99,
        maxInputVolatge: 1100,
        startUpVoltage: 250,
        operatingVoltage: 1000,
        mppt: 64,
        mscc: 100,
        noOfMPPT: 5,
        noOfStrings: 20,
        acCurrent: 199.3,
        dataSheet1: "../images/Inverter/Sineng/110-125-1.jpg",
        dataSheet2: "../images/Inverter/Sineng/110-125-2.jpg",
      },
      {
        name: "SP-350K-H1",
        value: 350,
        outPutPower: 350000,
        pvPower: 420000,
        efficiency: 99,
        maxInputVolatge: 1500,
        startUpVoltage: 250,
        operatingVoltage: 500,
        mppt: 45,
        mscc: null,
        noOfMPPT: 12,
        noOfStrings: 24,
        acCurrent: 199.3,
        dataSheet1: "../images/Inverter/Sineng/350-1.png",
        dataSheet2: "../images/Inverter/Sineng/350-2.png",
      },
    ],
    powerSensor: ["No Power Sensor"],
    communicationDevice: ["No Communication Device", "WiFi", "Ethernet"],
  },

  {
    brand: "SOLIS",
    phase: "Three Phase",
    systemType: "On Grid",
    inverterType: [
      {
        name: "S5-GR3P 3K",
        value: 3,
        outPutPower: 3000,
        pvPower: 3600,
        efficiency: 98.3,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 1000,
        mppt: 16,
        mscc: 32,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 4.7,
        dataSheet1: "../images/Inverter/Solis/3-20GR3P1.png",
        dataSheet2: "../images/Inverter/Solis/3-20GR3P2.png",
      },
      {
        name: "S5-GR3P 4K",
        value: 4,
        outPutPower: 4000,
        pvPower: 4800,
        efficiency: 98.3,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 1000,
        mppt: 16,
        mscc: 32,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 6.4,
        dataSheet1: "../images/Inverter/Solis/3-20GR3P1.png",
        dataSheet2: "../images/Inverter/Solis/3-20GR3P2.png",
      },
      {
        name: "S5-GR3P 5K",
        value: 5,
        outPutPower: 5000,
        pvPower: 6000,
        efficiency: 98.3,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 1000,
        mppt: 16,
        mscc: 32,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 7.9,
        dataSheet1: "../images/Inverter/Solis/3-20GR3P1.png",
        dataSheet2: "../images/Inverter/Solis/3-20GR3P2.png",
      },
      {
        name: "S5-GR3P 6K",
        value: 6,
        outPutPower: 6000,
        pvPower: 7200,
        efficiency: 98.3,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 1000,
        mppt: 16,
        mscc: 32,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 9.5,
        dataSheet1: "../images/Inverter/Solis/3-20GR3P1.png",
        dataSheet2: "../images/Inverter/Solis/3-20GR3P2.png",
      },
      {
        name: "S5-GR3P 8K",
        value: 8,
        outPutPower: 8000,
        pvPower: 9600,
        efficiency: 98.5,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 1000,
        mppt: 16,
        mscc: 32,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 12.7,
        dataSheet1: "../images/Inverter/Solis/3-20GR3P1.png",
        dataSheet2: "../images/Inverter/Solis/3-20GR3P2.png",
      },
      {
        name: "S5-GR3P 9K",
        value: 9,
        outPutPower: 9000,
        pvPower: 10800,
        efficiency: 98.5,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 1000,
        mppt: 16,
        mscc: 32,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 14.3,
        dataSheet1: "../images/Inverter/Solis/3-20GR3P1.png",
        dataSheet2: "../images/Inverter/Solis/3-20GR3P2.png",
      },
      {
        name: "S5-GR3P 10K",
        value: 10,
        outPutPower: 10000,
        pvPower: 12000,
        efficiency: 98.5,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 1000,
        mppt: 16,
        mscc: 32,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 15.9,
        dataSheet1: "../images/Inverter/Solis/3-20GR3P1.png",
        dataSheet2: "../images/Inverter/Solis/3-20GR3P2.png",
      },
      {
        name: "S5-GR3P 12K",
        value: 12,
        outPutPower: 12000,
        pvPower: 14400,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 1000,
        mppt: 32,
        mscc: 40,
        noOfMPPT: 2,
        noOfStrings: 8,
        acCurrent: 19.1,
        dataSheet1: "../images/Inverter/Solis/3-20GR3P1.png",
        dataSheet2: "../images/Inverter/Solis/3-20GR3P2.png",
      },
      {
        name: "S5-GR3P 13K",
        value: 13,
        outPutPower: 13000,
        pvPower: 15600,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 1000,
        mppt: 32,
        mscc: 40,
        noOfMPPT: 2,
        noOfStrings: 8,
        acCurrent: 20.7,
        dataSheet1: "../images/Inverter/Solis/3-20GR3P1.png",
        dataSheet2: "../images/Inverter/Solis/3-20GR3P2.png",
      },
      {
        name: "S5-GR3P 15K",
        value: 15,
        outPutPower: 15000,
        pvPower: 18000,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 1000,
        mppt: 32,
        mscc: 40,
        noOfMPPT: 2,
        noOfStrings: 8,
        acCurrent: 23.8,
        dataSheet1: "../images/Inverter/Solis/3-20GR3P1.png",
        dataSheet2: "../images/Inverter/Solis/3-20GR3P2.png",
      },
      {
        name: "S5-GR3P 17K",
        value: 17,
        outPutPower: 17000,
        pvPower: 20400,
        efficiency: 98.7,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 1000,
        mppt: 32,
        mscc: 40,
        noOfMPPT: 2,
        noOfStrings: 8,
        acCurrent: 27,
        dataSheet1: "../images/Inverter/Solis/3-20GR3P1.png",
        dataSheet2: "../images/Inverter/Solis/3-20GR3P2.png",
      },
      {
        name: "S5-GR3P 20K",
        value: 20,
        outPutPower: 20000,
        pvPower: 24000,
        efficiency: 98.7,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 1000,
        mppt: 32,
        mscc: 40,
        noOfMPPT: 2,
        noOfStrings: 8,
        acCurrent: 31.8,
        dataSheet1: "../images/Inverter/Solis/3-20GR3P1.png",
        dataSheet2: "../images/Inverter/Solis/3-20GR3P2.png",
      },
      {
        name: "S5-GC 50K",
        value: 50,
        outPutPower: 50000,
        pvPower: 60000,
        efficiency: 98.7,
        maxInputVolatge: 1100,
        startUpVoltage: 195,
        operatingVoltage: 1000,
        mppt: 32,
        mscc: 40,
        noOfMPPT: 5,
        noOfStrings: 10,
        acCurrent: 83.6,
        dataSheet1: "../images/Inverter/Solis/50-60GC1.png",
        dataSheet2: "../images/Inverter/Solis/50-60GC2.png",
      },
      {
        name: "S5-GC 60K",
        value: 60,
        outPutPower: 60000,
        pvPower: 72000,
        efficiency: 98.7,
        maxInputVolatge: 1100,
        startUpVoltage: 195,
        operatingVoltage: 1000,
        mppt: 32,
        mscc: 40,
        noOfMPPT: 6,
        noOfStrings: 12,
        acCurrent: 100.3,
        dataSheet1: "../images/Inverter/Solis/50-60GC1.png",
        dataSheet2: "../images/Inverter/Solis/50-60GC2.png",
      },
      {
        name: "S5-GC 60K LV",
        value: 60,
        outPutPower: 60000,
        pvPower: 72000,
        efficiency: 98.7,
        maxInputVolatge: 1100,
        startUpVoltage: 195,
        operatingVoltage: 1000,
        mppt: 32,
        mscc: 40,
        noOfMPPT: 6,
        noOfStrings: 12,
        acCurrent: 144.3,
        dataSheet1: "../images/Inverter/Solis/50-60KLV1.png",
        dataSheet2: "../images/Inverter/Solis/50-60KLV2.png",
      },
      {
        name: "S5-GC 70K LV",
        value: 70,
        outPutPower: 70000,
        pvPower: 84000,
        efficiency: 98.7,
        maxInputVolatge: 1100,
        startUpVoltage: 195,
        operatingVoltage: 1000,
        mppt: 32,
        mscc: 40,
        noOfMPPT: 8,
        noOfStrings: 16,
        acCurrent: 173.2,
        dataSheet1: "../images/Inverter/Solis/50-60KLV1.png",
        dataSheet2: "../images/Inverter/Solis/50-60KLV2.png",
      },
      {
        name: "Solis-5G-PRO 80K",
        value: 80,
        outPutPower: 80000,
        pvPower: 96000,
        efficiency: 98.5,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 1000,
        mppt: 40,
        mscc: 50,
        noOfMPPT: 6,
        noOfStrings: 12,
        acCurrent: 133.7,
        dataSheet1: "../images/Inverter/Solis/80-110K5GPRO1.png",
        dataSheet2: "../images/Inverter/Solis/80-110K5GPRO2.png",
      },
      {
        name: "Solis-5G-PRO 100K",
        value: 100,
        outPutPower: 100000,
        pvPower: 120000,
        efficiency: 98.5,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 1000,
        mppt: 40,
        mscc: 50,
        noOfMPPT: 8,
        noOfStrings: 16,
        acCurrent: 167.1,
        dataSheet1: "../images/Inverter/Solis/80-110K5GPRO1.png",
        dataSheet2: "../images/Inverter/Solis/80-110K5GPRO2.png",
      },
      {
        name: "Solis-5G-PRO 110K",
        value: 110,
        outPutPower: 110000,
        pvPower: 132000,
        efficiency: 98.5,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 1000,
        mppt: 40,
        mscc: 50,
        noOfMPPT: 8,
        noOfStrings: 16,
        acCurrent: 183.8,
        dataSheet1: "../images/Inverter/Solis/80-110K5GPRO1.png",
        dataSheet2: "../images/Inverter/Solis/80-110K5GPRO2.png",
      },
    ],
    powerSensor: ["No Power Sensor", " Acrel Meter", "EPM3-5G-Pro"],
    communicationDevice: [
      "No Communication Device",
      "S1-W4G-ST",
      "S2-WL-ST",
      "S3-WIFI-ST",
      "S4-WIFI-ST",
    ],
  },
  {
    brand: "SOLIS",
    phase: "Single Phase",
    systemType: "Hybrid",
    inverterType: [
      {
        name: "S6-EH1PL-PRO 3K",
        value: 3,
        outPutPower: 3000,
        pvPower: 3600,
        efficiency: 97.5,
        maxInputVolatge: 600,
        startUpVoltage: 90,
        operatingVoltage: 520,
        mppt: 16,
        mscc: 24,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 20,
        dataSheet1: "../images/Inverter/Solis/3-20GR3P1.png",
        dataSheet2: "../images/Inverter/Solis/3-20GR3P2.png",
      },
      {
        name: "S6-EH1PL-PRO 3.6K",
        value: 3.6,
        outPutPower: 3600,
        pvPower: 4320,
        efficiency: 97.5,
        maxInputVolatge: 600,
        startUpVoltage: 90,
        operatingVoltage: 520,
        mppt: 16,
        mscc: 24,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 25,
        dataSheet1: "../images/Inverter/Solis/3-20GR3P1.png",
        dataSheet2: "../images/Inverter/Solis/3-20GR3P2.png",
      },
      {
        name: "S6-EH1PL-PRO 5K",
        value: 5,
        outPutPower: 5000,
        pvPower: 6000,
        efficiency: 97.5,
        maxInputVolatge: 600,
        startUpVoltage: 90,
        operatingVoltage: 520,
        mppt: 16,
        mscc: 24,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 32,
        dataSheet1: "../images/Inverter/Solis/3-20GR3P1.png",
        dataSheet2: "../images/Inverter/Solis/3-20GR3P2.png",
      },
      {
        name: "S6-EH1PL-PRO 6K",
        value: 6,
        outPutPower: 6000,
        pvPower: 7200,
        efficiency: 97.5,
        maxInputVolatge: 600,
        startUpVoltage: 90,
        operatingVoltage: 520,
        mppt: 16,
        mscc: 24,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 40,
        dataSheet1: "../images/Inverter/Solis/3-20GR3P1.png",
        dataSheet2: "../images/Inverter/Solis/3-20GR3P2.png",
      },
      {
        name: "S6-EH1PL-PRO 8K",
        value: 8,
        outPutPower: 8000,
        pvPower: 9600,
        efficiency: 97.5,
        maxInputVolatge: 600,
        startUpVoltage: 90,
        operatingVoltage: 520,
        mppt: 16,
        mscc: 24,
        noOfMPPT: 2,
        noOfStrings: 6,
        acCurrent: 50,
        dataSheet1: "../images/Inverter/Solis/3-20GR3P1.png",
        dataSheet2: "../images/Inverter/Solis/3-20GR3P2.png",
      },
    ],
    powerSensor: ["No Power Sensor", " Acrel Meter", "EPM3-5G-Pro"],
    communicationDevice: [
      "No Communication Device",
      "S1-W4G-ST",
      "S2-WL-ST",
      "S3-WIFI-ST",
      "S4-WIFI-ST",
    ],
  },

  {
    brand: "GOODWE",
    phase: "Three Phase",
    systemType: "On Grid",
    inverterType: [
      {
        name: "GW4000-SDT-20",
        value: 4,
        outPutPower: 4000,
        pvPower: 4800,
        efficiency: 98.2,
        maxInputVolatge: 1000,
        startUpVoltage: 180,
        operatingVoltage: 850,
        mppt: 16,
        mscc: 20,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 6.4,
        dataSheet1: "../images/Inverter/GoodWe/4-20-1.jpg",
        dataSheet2: "../images/Inverter/GoodWe/4-20-2.jpg",
      },
      {
        name: "GW5000-SDT-20",
        value: 5,
        outPutPower: 5000,
        pvPower: 6000,
        efficiency: 98.2,
        maxInputVolatge: 1000,
        startUpVoltage: 180,
        operatingVoltage: 850,
        mppt: 16,
        mscc: 20,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 8,
        dataSheet1: "../images/Inverter/GoodWe/4-20-1.jpg",
        dataSheet2: "../images/Inverter/GoodWe/4-20-2.jpg",
      },
      {
        name: "GW6000-SDT-20",
        value: 6,
        outPutPower: 6000,
        pvPower: 7200,
        efficiency: 98.2,
        maxInputVolatge: 1000,
        startUpVoltage: 180,
        operatingVoltage: 850,
        mppt: 16,
        mscc: 20,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 9.6,
        dataSheet1: "../images/Inverter/GoodWe/4-20-1.jpg",
        dataSheet2: "../images/Inverter/GoodWe/4-20-2.jpg",
      },
      {
        name: "GW8000-SDT-20",
        value: 8,
        outPutPower: 8000,
        pvPower: 9600,
        efficiency: 98.3,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 950,
        mppt: 15,
        mscc: 18.7,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 12.8,
        dataSheet1: "../images/Inverter/GoodWe/4-20-1.jpg",
        dataSheet2: "../images/Inverter/GoodWe/4-20-2.jpg",
      },
      {
        name: "GW10K-SDT-20",
        value: 10,
        outPutPower: 10000,
        pvPower: 12000,
        efficiency: 98.3,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 950,
        mppt: 15,
        mscc: 18.7,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 16,
        dataSheet1: "../images/Inverter/GoodWe/4-20-1.jpg",
        dataSheet2: "../images/Inverter/GoodWe/4-20-2.jpg",
      },
      {
        name: "GW12K-SDT-20",
        value: 12,
        outPutPower: 12000,
        pvPower: 14400,
        efficiency: 98.4,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 950,
        mppt: 30,
        mscc: 37.5,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 19.1,
        dataSheet1: "../images/Inverter/GoodWe/4-20-1.jpg",
        dataSheet2: "../images/Inverter/GoodWe/4-20-2.jpg",
      },
      {
        name: "GW12KLV-SDT-20",
        value: 12,
        outPutPower: 12000,
        pvPower: 14400,
        efficiency: 96.9,
        maxInputVolatge: 800,
        startUpVoltage: 180,
        operatingVoltage: 650,
        mppt: 30,
        mscc: 37.5,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 31.9,
        dataSheet1: "../images/Inverter/GoodWe/4-20-1.jpg",
        dataSheet2: "../images/Inverter/GoodWe/4-20-2.jpg",
      },
      {
        name: "GW15K-SDT-20",
        value: 15,
        outPutPower: 15000,
        pvPower: 18000,
        efficiency: 98.4,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 950,
        mppt: 30,
        mscc: 37.5,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 24,
        dataSheet1: "../images/Inverter/GoodWe/4-20-1.jpg",
        dataSheet2: "../images/Inverter/GoodWe/4-20-2.jpg",
      },
      {
        name: "GW17K-SDT-20",
        value: 17,
        outPutPower: 17000,
        pvPower: 20400,
        efficiency: 98.4,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 950,
        mppt: 30,
        mscc: 37.5,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 27.1,
        dataSheet1: "../images/Inverter/GoodWe/4-20-1.jpg",
        dataSheet2: "../images/Inverter/GoodWe/4-20-2.jpg",
      },
      {
        name: "GW20K-SDT-20",
        value: 20,
        outPutPower: 20000,
        pvPower: 24000,
        efficiency: 98.4,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 950,
        mppt: 30,
        mscc: 37.5,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 32,
        dataSheet1: "../images/Inverter/GoodWe/4-20-1.jpg",
        dataSheet2: "../images/Inverter/GoodWe/4-20-2.jpg",
      },
      {
        name: "GW25K-MT",
        value: 25,
        outPutPower: 25000,
        pvPower: 30000,
        efficiency: 98.7,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 950,
        mppt: 30,
        mscc: 37.5,
        noOfMPPT: 3,
        noOfStrings: 6,
        acCurrent: 40,
        dataSheet1: "../images/Inverter/GoodWe/25-36-1.jpg",
        dataSheet2: "../images/Inverter/GoodWe/25-36-2.jpg",
      },
      {
        name: "GW29.9K-MT",
        value: 29.9,
        outPutPower: 29900,
        pvPower: 35880,
        efficiency: 98.8,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 950,
        mppt: 30,
        mscc: 37.5,
        noOfMPPT: 3,
        noOfStrings: 6,
        acCurrent: 43.3,
        dataSheet1: "../images/Inverter/GoodWe/25-36-1.jpg",
        dataSheet2: "../images/Inverter/GoodWe/25-36-2.jpg",
      },
      {
        name: "GW30K-MT",
        value: 30,
        outPutPower: 30000,
        pvPower: 36000,
        efficiency: 98.8,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 950,
        mppt: 30,
        mscc: 37.5,
        noOfMPPT: 3,
        noOfStrings: 6,
        acCurrent: 48,
        dataSheet1: "../images/Inverter/GoodWe/25-36-1.jpg",
        dataSheet2: "../images/Inverter/GoodWe/25-36-2.jpg",
      },
      {
        name: "GW36K-MT",
        value: 36,
        outPutPower: 36000,
        pvPower: 43200,
        efficiency: 98.8,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 950,
        mppt: 30,
        mscc: 37.5,
        noOfMPPT: 3,
        noOfStrings: 6,
        acCurrent: 53.3,
        dataSheet1: "../images/Inverter/GoodWe/25-36-1.jpg",
        dataSheet2: "../images/Inverter/GoodWe/25-36-2.jpg",
      },
      {
        name: "GW50KS-MT",
        value: 50,
        outPutPower: 50000,
        pvPower: 60000,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 950,
        mppt: 30,
        mscc: 37.5,
        noOfMPPT: 5,
        noOfStrings: 10,
        acCurrent: 80,
        dataSheet1: "../images/Inverter/GoodWe/50-60-1.jpg",
        dataSheet2: "../images/Inverter/GoodWe/50-60-2.jpg",
      },
      {
        name: "GW60KS-MT",
        value: 60,
        outPutPower: 60000,
        pvPower: 72000,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 180,
        operatingVoltage: 950,
        mppt: 30,
        mscc: 37.5,
        noOfMPPT: 6,
        noOfStrings: 12,
        acCurrent: 96,
        dataSheet1: "../images/Inverter/GoodWe/50-60-1.jpg",
        dataSheet2: "../images/Inverter/GoodWe/50-60-2.jpg",
      },
      {
        name: "GW73KLV-HT",
        value: 73,
        outPutPower: 73000,
        pvPower: 87600,
        efficiency: 98.4,
        maxInputVolatge: 800,
        startUpVoltage: 200,
        operatingVoltage: 650,
        mppt: 30,
        mscc: 45,
        noOfMPPT: 12,
        noOfStrings: 24,
        acCurrent: 192,
        dataSheet1: "../images/Inverter/GoodWe/73-120-1.jpg",
        dataSheet2: "../images/Inverter/GoodWe/73-120-2.jpg",
      },
      {
        name: "GW75K-HT",
        value: 75,
        outPutPower: 75000,
        pvPower: 90000,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 200,
        operatingVoltage: 1000,
        mppt: 30,
        mscc: 45,
        noOfMPPT: 10,
        noOfStrings: 20,
        acCurrent: 125.3,
        dataSheet1: "../images/Inverter/GoodWe/73-120-1.jpg",
        dataSheet2: "../images/Inverter/GoodWe/73-120-2.jpg",
      },
      {
        name: "GW80K-HT",
        value: 80,
        outPutPower: 80000,
        pvPower: 96000,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 200,
        operatingVoltage: 1000,
        mppt: 30,
        mscc: 45,
        noOfMPPT: 10,
        noOfStrings: 20,
        acCurrent: 134,
        dataSheet1: "../images/Inverter/GoodWe/73-120-1.jpg",
        dataSheet2: "../images/Inverter/GoodWe/73-120-2.jpg",
      },
      {
        name: "GW100K-HT",
        value: 100,
        outPutPower: 100000,
        pvPower: 120000,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 200,
        operatingVoltage: 1000,
        mppt: 30,
        mscc: 45,
        noOfMPPT: 10,
        noOfStrings: 20,
        acCurrent: 167,
        dataSheet1: "../images/Inverter/GoodWe/73-120-1.jpg",
        dataSheet2: "../images/Inverter/GoodWe/73-120-2.jpg",
      },
      {
        name: "GW110K-HT",
        value: 110,
        outPutPower: 110000,
        pvPower: 132000,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 200,
        operatingVoltage: 1000,
        mppt: 30,
        mscc: 45,
        noOfMPPT: 12,
        noOfStrings: 24,
        acCurrent: 175.5,
        dataSheet1: "../images/Inverter/GoodWe/73-120-1.jpg",
        dataSheet2: "../images/Inverter/GoodWe/73-120-2.jpg",
      },
      {
        name: "GW120K-HT",
        value: 120,
        outPutPower: 120000,
        pvPower: 144000,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 200,
        operatingVoltage: 1000,
        mppt: 30,
        mscc: 45,
        noOfMPPT: 10,
        noOfStrings: 20,
        acCurrent: 191.3,
        dataSheet1: "../images/Inverter/GoodWe/73-120-1.jpg",
        dataSheet2: "../images/Inverter/GoodWe/73-120-2.jpg",
      },
    ],
    powerSensor: ["No Power Sensor"],
    communicationDevice: [
      "No Communication Device",
      "RS485",
      "WIFI",
      "Ethernet",
    ],
  },

  {
    brand: "GROWATT",
    phase: "Three Phase",
    systemType: "On Grid",
    inverterType: [
      {
        name: "MOD 3000TL3-X",
        value: 3,
        outPutPower: 3000,
        pvPower: 3600,
        efficiency: 98.3,
        maxInputVolatge: 1100,
        startUpVoltage: 160,
        operatingVoltage: 1000,
        mppt: 13,
        mscc: 16,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 5,
        dataSheet1: "../images/Inverter/Growatt/3-9MOD1.png",
        dataSheet2: "../images/Inverter/Growatt/3-9MOD2.png",
      },
      {
        name: "MOD 4000TL3-X",
        value: 4,
        outPutPower: 4000,
        pvPower: 4800,
        efficiency: 98.3,
        maxInputVolatge: 1100,
        startUpVoltage: 160,
        operatingVoltage: 1000,
        mppt: 13,
        mscc: 16,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 6.7,
        dataSheet1: "../images/Inverter/Growatt/3-9MOD1.png",
        dataSheet2: "../images/Inverter/Growatt/3-9MOD2.png",
      },
      {
        name: "MOD 5000TL3-X",
        value: 5,
        outPutPower: 5000,
        pvPower: 6000,
        efficiency: 98.3,
        maxInputVolatge: 1100,
        startUpVoltage: 160,
        operatingVoltage: 1000,
        mppt: 13,
        mscc: 16,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 8.3,
        dataSheet1: "../images/Inverter/Growatt/3-9MOD1.png",
        dataSheet2: "../images/Inverter/Growatt/3-9MOD2.png",
      },
      {
        name: "MOD 6000TL3-X",
        value: 6,
        outPutPower: 6000,
        pvPower: 7200,
        efficiency: 98.3,
        maxInputVolatge: 1100,
        startUpVoltage: 160,
        operatingVoltage: 1000,
        mppt: 13,
        mscc: 16,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 10,
        dataSheet1: "../images/Inverter/Growatt/3-9MOD1.png",
        dataSheet2: "../images/Inverter/Growatt/3-9MOD2.png",
      },
      {
        name: "MOD 7000TL3-X",
        value: 7,
        outPutPower: 7000,
        pvPower: 8400,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 160,
        operatingVoltage: 1000,
        mppt: 13,
        mscc: 16,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 11.7,
        dataSheet1: "../images/Inverter/Growatt/3-9MOD1.png",
        dataSheet2: "../images/Inverter/Growatt/3-9MOD2.png",
      },
      {
        name: "MOD 8000TL3-X",
        value: 8,
        outPutPower: 8000,
        pvPower: 9600,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 160,
        operatingVoltage: 1000,
        mppt: 13,
        mscc: 16,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 13.3,
        dataSheet1: "../images/Inverter/Growatt/3-9MOD1.png",
        dataSheet2: "../images/Inverter/Growatt/3-9MOD2.png",
      },
      {
        name: "MOD 9000TL3-X",
        value: 9,
        outPutPower: 9000,
        pvPower: 10800,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 160,
        operatingVoltage: 1000,
        mppt: 13,
        mscc: 16,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 15,
        dataSheet1: "../images/Inverter/Growatt/3-9MOD1.png",
        dataSheet2: "../images/Inverter/Growatt/3-9MOD2.png",
      },
      {
        name: "MOD 10kTL3-X",
        value: 10,
        outPutPower: 10000,
        pvPower: 12000,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 160,
        operatingVoltage: 1000,
        mppt: 12,
        mscc: 16,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 16.7,
        dataSheet1: "../images/Inverter/Growatt/10-15MOD1.png",
        dataSheet2: "../images/Inverter/Growatt/10-15MOD2.png",
      },
      {
        name: "MOD 11kTL3-X",
        value: 11,
        outPutPower: 11000,
        pvPower: 13200,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 160,
        operatingVoltage: 1000,
        mppt: 12,
        mscc: 16,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 18.3,
        dataSheet1: "../images/Inverter/Growatt/10-15MOD1.png",
        dataSheet2: "../images/Inverter/Growatt/10-15MOD2.png",
      },
      {
        name: "MOD 12kTL3-X",
        value: 12,
        outPutPower: 12000,
        pvPower: 14400,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 160,
        operatingVoltage: 1000,
        mppt: 12,
        mscc: 16,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 20,
        dataSheet1: "../images/Inverter/Growatt/10-15MOD1.png",
        dataSheet2: "../images/Inverter/Growatt/10-15MOD2.png",
      },
      {
        name: "MOD 13kTL3-X",
        value: 13,
        outPutPower: 13000,
        pvPower: 15600,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 160,
        operatingVoltage: 1000,
        mppt: 12,
        mscc: 16,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 21.7,
        dataSheet1: "../images/Inverter/Growatt/10-15MOD1.png",
        dataSheet2: "../images/Inverter/Growatt/10-15MOD2.png",
      },
      {
        name: "MOD 15kTL3-X",
        value: 15,
        outPutPower: 15000,
        pvPower: 18000,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 160,
        operatingVoltage: 1000,
        mppt: 12,
        mscc: 16,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 25,
        dataSheet1: "../images/Inverter/Growatt/10-15MOD1.png",
        dataSheet2: "../images/Inverter/Growatt/10-15MOD2.png",
      },
      {
        name: "MID 20kTL3-X",
        value: 20,
        outPutPower: 20000,
        pvPower: 24000,
        efficiency: 98.75,
        maxInputVolatge: 1100,
        startUpVoltage: 580,
        operatingVoltage: 1000,
        mppt: 27,
        mscc: 33.8,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 31.9,
        dataSheet1: "../images/Inverter/Growatt/MID15-25KL3-X-1.png",
        dataSheet2: "../images/Inverter/Growatt/MID15-25KL3-X-2.png",
      },
      {
        name: "MID 25kTL3-X",
        value: 25,
        outPutPower: 25000,
        pvPower: 30000,
        efficiency: 98.75,
        maxInputVolatge: 1100,
        startUpVoltage: 580,
        operatingVoltage: 1000,
        mppt: 27,
        mscc: 33.8,
        noOfMPPT: 2,
        noOfStrings: 6,
        acCurrent: 40.2,
        dataSheet1: "../images/Inverter/Growatt/MID15-25KL3-X-1.png",
        dataSheet2: "../images/Inverter/Growatt/MID15-25KL3-X-2.png",
      },
      {
        name: "MID 30kTL3-X",
        value: 30,
        outPutPower: 30000,
        pvPower: 36000,
        efficiency: 98.8,
        maxInputVolatge: 1100,
        startUpVoltage: 600,
        operatingVoltage: 1000,
        mppt: 26,
        mscc: 32,
        noOfMPPT: 3,
        noOfStrings: 6,
        acCurrent: 50.5,
        dataSheet1: "../images/Inverter/Growatt/MID25-40KL3-X-1.png",
        dataSheet2: "../images/Inverter/Growatt/MID25-40KL3-X-2.png",
      },
    ],
    powerSensor: [
      "No Power Sensor",
      "ESTRON TPM-CT-E-EU",
      "ESTRON TPM-CT-E-USr",
      "ESTRON Smart Mete",
    ],
    communicationDevice: [
      "No Communication Device",
      "ShineWiFi/4F/Lan-X",
      "SineLink-X",
      "ShineMaster",
      "ShineWifi/GPRS-F",
    ],
  },
  {
    brand: "GROWATT",
    phase: "Single Phase",
    systemType: "Hybrid",
    inverterType: [
      {
        name: "SPH 3000TL BL-HP",
        value: 3,
        outPutPower: 3000,
        pvPower: 3600,
        efficiency: 97.2,
        maxInputVolatge: 550,
        startUpVoltage: 120,
        operatingVoltage: 550,
        mppt: 13.5,
        mscc: 16.9,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 13.5,
        dataSheet1: "../images/Inverter/Growatt/3-9MOD1.png",
        dataSheet2: "../images/Inverter/Growatt/3-9MOD2.png",
      },
      {
        name: "SPH 3600TL BL-HP",
        value: 3.6,
        outPutPower: 3600,
        pvPower: 4320,
        efficiency: 97.2,
        maxInputVolatge: 550,
        startUpVoltage: 120,
        operatingVoltage: 550,
        mppt: 13.5,
        mscc: 16.9,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 16,
        dataSheet1: "../images/Inverter/Growatt/3-9MOD1.png",
        dataSheet2: "../images/Inverter/Growatt/3-9MOD2.png",
      },
      {
        name: "SPH 4000TL BL-HP",
        value: 4,
        outPutPower: 4000,
        pvPower: 4800,
        efficiency: 97.3,
        maxInputVolatge: 550,
        startUpVoltage: 120,
        operatingVoltage: 550,
        mppt: 13.5,
        mscc: 16.9,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 17.5,
        dataSheet1: "../images/Inverter/Growatt/3-9MOD1.png",
        dataSheet2: "../images/Inverter/Growatt/3-9MOD2.png",
      },
      {
        name: "SPH 4600TL BL-HP",
        value: 4.6,
        outPutPower: 4600,
        pvPower: 5520,
        efficiency: 97.4,
        maxInputVolatge: 550,
        startUpVoltage: 120,
        operatingVoltage: 550,
        mppt: 13.5,
        mscc: 16.9,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 20,
        dataSheet1: "../images/Inverter/Growatt/3-9MOD1.png",
        dataSheet2: "../images/Inverter/Growatt/3-9MOD2.png",
      },
      {
        name: "SPH 5000TL BL-HP",
        value: 5,
        outPutPower: 5000,
        pvPower: 6000,
        efficiency: 97.5,
        maxInputVolatge: 550,
        startUpVoltage: 120,
        operatingVoltage: 550,
        mppt: 13.5,
        mscc: 16.9,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 22,
        dataSheet1: "../images/Inverter/Growatt/3-9MOD1.png",
        dataSheet2: "../images/Inverter/Growatt/3-9MOD2.png",
      },
      {
        name: "SPH 6000TL BL-HP",
        value: 6,
        outPutPower: 6000,
        pvPower: 7200,
        efficiency: 97.6,
        maxInputVolatge: 550,
        startUpVoltage: 120,
        operatingVoltage: 550,
        mppt: 13.5,
        mscc: 16.9,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 27,
        dataSheet1: "../images/Inverter/Growatt/3-9MOD1.png",
        dataSheet2: "../images/Inverter/Growatt/3-9MOD2.png",
      },
    ],
    powerSensor: [
      "No Power Sensor",
      "ESTRON TPM-CT-E-EU",
      "ESTRON TPM-CT-E-USr",
      "ESTRON Smart Mete",
    ],
    communicationDevice: [
      "No Communication Device",
      "ShineWiFi/4F/Lan-X",
      "SineLink-X",
      "ShineMaster",
      "ShineWifi/GPRS-F",
    ],
  },
  {
    brand: "GROWATT",
    phase: "Three Phase",
    systemType: "Hybrid",
    inverterType: [
      {
        name: "SPH 4000TL BL-HP",
        value: 4,
        outPutPower: 3000,
        pvPower: 3600,
        efficiency: 97.6,
        maxInputVolatge: 1000,
        startUpVoltage: 120,
        operatingVoltage: 1000,
        mppt: 13.5,
        mscc: 16.9,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 6.1,
        dataSheet1: "../images/Inverter/Growatt/3-9MOD1.png",
        dataSheet2: "../images/Inverter/Growatt/3-9MOD2.png",
      },
      {
        name: "SPH 5000TL BL-HP",
        value: 5,
        outPutPower: 5000,
        pvPower: 6000,
        efficiency: 97.8,
        maxInputVolatge: 1000,
        startUpVoltage: 120,
        operatingVoltage: 1000,
        mppt: 13.5,
        mscc: 16.9,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 7.6,
        dataSheet1: "../images/Inverter/Growatt/3-9MOD1.png",
        dataSheet2: "../images/Inverter/Growatt/3-9MOD2.png",
      },
      {
        name: "SPH 6000TL BL-HP",
        value: 6,
        outPutPower: 6000,
        pvPower: 7200,
        efficiency: 98,
        maxInputVolatge: 1000,
        startUpVoltage: 120,
        operatingVoltage: 1000,
        mppt: 13.5,
        mscc: 16.9,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 9.1,
        dataSheet1: "../images/Inverter/Growatt/3-9MOD1.png",
        dataSheet2: "../images/Inverter/Growatt/3-9MOD2.png",
      },
      {
        name: "SPH 7000TL BL-HP",
        value: 7,
        outPutPower: 7000,
        pvPower: 8400,
        efficiency: 98.2,
        maxInputVolatge: 1000,
        startUpVoltage: 120,
        operatingVoltage: 1000,
        mppt: 13.5,
        mscc: 16.9,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 10.6,
        dataSheet1: "../images/Inverter/Growatt/3-9MOD1.png",
        dataSheet2: "../images/Inverter/Growatt/3-9MOD2.png",
      },
      {
        name: "SPH 8000TL BL-HP",
        value: 8,
        outPutPower: 8000,
        pvPower: 9600,
        efficiency: 98.2,
        maxInputVolatge: 1000,
        startUpVoltage: 120,
        operatingVoltage: 1000,
        mppt: 13.5,
        mscc: 16.9,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 12.1,
        dataSheet1: "../images/Inverter/Growatt/3-9MOD1.png",
        dataSheet2: "../images/Inverter/Growatt/3-9MOD2.png",
      },
      {
        name: "SPH 10000TL BL-HP",
        value: 10,
        outPutPower: 10000,
        pvPower: 12000,
        efficiency: 98.2,
        maxInputVolatge: 1000,
        startUpVoltage: 120,
        operatingVoltage: 1000,
        mppt: 13.5,
        mscc: 16.9,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 15.2,
        dataSheet1: "../images/Inverter/Growatt/3-9MOD1.png",
        dataSheet2: "../images/Inverter/Growatt/3-9MOD2.png",
      },
    ],
    powerSensor: [
      "No Power Sensor",
      "ESTRON TPM-CT-E-EU",
      "ESTRON TPM-CT-E-USr",
      "ESTRON Smart Mete",
    ],
    communicationDevice: [
      "No Communication Device",
      "ShineWiFi/4F/Lan-X",
      "SineLink-X",
      "ShineMaster",
      "ShineWifi/GPRS-F",
    ],
  },

  {
    brand: "INVEREX NITROX",
    phase: "Three Phase",
    systemType: "On Grid",
    inverterType: [
      {
        name: "Inverex Nitrox 6KW",
        value: 6,
        outPutPower: 6000,
        pvPower: 7200,
        efficiency: 98.6,
        maxInputVolatge: 1000,
        startUpVoltage: 250,
        operatingVoltage: 850,
        mppt: 13,
        mscc: 19.5,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 9.6,
        dataSheet1: "../images/Inverter/Inverex/6-20KW1.png",
        dataSheet2: "../images/Inverter/Inverex/6-20KW2.png",
      },
      {
        name: "Inverex Nitrox 10KW",
        value: 10,
        outPutPower: 10000,
        pvPower: 12000,
        efficiency: 98.6,
        maxInputVolatge: 1000,
        startUpVoltage: 250,
        operatingVoltage: 850,
        mppt: 13,
        mscc: 19.5,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 15.9,
        dataSheet1: "../images/Inverter/Inverex/6-20KW1.png",
        dataSheet2: "../images/Inverter/Inverex/6-20KW2.png",
      },
      {
        name: "Inverex Nitrox 15KW",
        value: 15,
        outPutPower: 15000,
        pvPower: 18000,
        efficiency: 98.6,
        maxInputVolatge: 1000,
        startUpVoltage: 250,
        operatingVoltage: 850,
        mppt: 13,
        mscc: 19.5,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 23.9,
        dataSheet1: "../images/Inverter/Inverex/6-20KW1.png",
        dataSheet2: "../images/Inverter/Inverex/6-20KW2.png",
      },
      {
        name: "Inverex Nitrox 20KW",
        value: 20,
        outPutPower: 20000,
        pvPower: 24000,
        efficiency: 98.6,
        maxInputVolatge: 1000,
        startUpVoltage: 250,
        operatingVoltage: 850,
        mppt: 32,
        mscc: 48,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 31.9,
        dataSheet1: "../images/Inverter/Inverex/6-20KW1.png",
        dataSheet2: "../images/Inverter/Inverex/6-20KW2.png",
      },
      {
        name: "Inverex Nitrox 35KW",
        value: 35,
        outPutPower: 35000,
        pvPower: 42000,
        efficiency: 98.6,
        maxInputVolatge: 1000,
        startUpVoltage: 250,
        operatingVoltage: 850,
        mppt: 40,
        mscc: 60,
        noOfMPPT: 2,
        noOfStrings: 6,
        acCurrent: 55.8,
        dataSheet1: "../images/Inverter/Inverex/35KW1.png",
        dataSheet2: "../images/Inverter/Inverex/35KW2.png",
      },
      {
        name: "Inverex Nitrox 50KW",
        value: 50,
        outPutPower: 50000,
        pvPower: 60000,
        efficiency: 98.7,
        maxInputVolatge: 1000,
        startUpVoltage: 250,
        operatingVoltage: 850,
        mppt: 40,
        mscc: 60,
        noOfMPPT: 4,
        noOfStrings: 12,
        acCurrent: 79.7,
        dataSheet1: "../images/Inverter/Inverex/50-100KW1.png",
        dataSheet2: "../images/Inverter/Inverex/50-100KW2.png",
      },
      {
        name: "Inverex Nitrox 75KW",
        value: 75,
        outPutPower: 75000,
        pvPower: 90000,
        efficiency: 98.7,
        maxInputVolatge: 1000,
        startUpVoltage: 250,
        operatingVoltage: 850,
        mppt: 40,
        mscc: 60,
        noOfMPPT: 4,
        noOfStrings: 16,
        acCurrent: 119.6,
        dataSheet1: "../images/Inverter/Inverex/50-100KW1.png",
        dataSheet2: "../images/Inverter/Inverex/50-100KW2.png",
      },
      {
        name: "Inverex Nitrox 100KW",
        value: 100,
        outPutPower: 100000,
        pvPower: 120000,
        efficiency: 98.7,
        maxInputVolatge: 1000,
        startUpVoltage: 250,
        operatingVoltage: 850,
        mppt: 40,
        mscc: 60,
        noOfMPPT: 4,
        noOfStrings: 24,
        acCurrent: 159.4,
        dataSheet1: "../images/Inverter/Inverex/50-100KW1.png",
        dataSheet2: "../images/Inverter/Inverex/50-100KW2.png",
      },
    ],
    powerSensor: ["No Power Sensor", "Power Sensor"],
    communicationDevice: [
      "No Communication Device",
      "SM Stick logger LSW-3-C(DB9)",
      "SM Stick logger LSW-3-C(USB)",
      "SM Stick logger LSW-5 (USB)",
      "SM Stick logger LS4G-5 (DB9)",
    ],
  },
  {
    brand: "INVEREX NITROX",
    phase: "Three Phase",
    systemType: "Hybrid",
    inverterType: [
      {
        name: "Inverex Nitrox 12KW",
        value: 12,
        outPutPower: 12000,
        pvPower: 14000,
        efficiency: 97.6,
        maxInputVolatge: 550,
        startUpVoltage: 160,
        operatingVoltage: 650,
        mppt: 13,
        mscc: 17,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 9.6,
        dataSheet1: "../images/Inverter/Inverex/6-20KW1.png",
        dataSheet2: "../images/Inverter/Inverex/6-20KW2.png",
      },
    ],
    powerSensor: ["No Power Sensor", "Power Sensor"],
    communicationDevice: [
      "No Communication Device",
      // "SM Stick logger LSW-3-C(DB9)",
      // "SM Stick logger LSW-3-C(USB)",
      // "SM Stick logger LSW-5 (USB)",
      // "SM Stick logger LS4G-5 (DB9)",
    ],
  },
  {
    brand: "INVEREX NITROX",
    phase: "Single Phase",
    systemType: "Hybrid",
    inverterType: [
      {
        name: "Inverex Nitrox 3KW",
        value: 3,
        outPutPower: 3000,
        pvPower: 3600,
        efficiency: 97.6,
        maxInputVolatge: 370,
        startUpVoltage: 125,
        operatingVoltage: 425,
        mppt: 13,
        mscc: 17,
        noOfMPPT: 1,
        noOfStrings: 2,
        acCurrent: 9.6,
        dataSheet1: "../images/Inverter/Inverex/6-20KW1.png",
        dataSheet2: "../images/Inverter/Inverex/6-20KW2.png",
      },
      {
        name: "Inverex Nitrox 6KW",
        value: 6,
        outPutPower: 6000,
        pvPower: 7200,
        efficiency: 97.6,
        maxInputVolatge: 370,
        startUpVoltage: 125,
        operatingVoltage: 425,
        mppt: 13,
        mscc: 17,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 9.6,
        dataSheet1: "../images/Inverter/Inverex/6kW-hybrid-1.jpg",
        dataSheet2: "../images/Inverter/Inverex/6kW-hybrid-2.jpg",
      },
      {
        name: "Inverex Nitrox 8KW",
        value: 8,
        outPutPower: 8000,
        pvPower: 9600,
        efficiency: 97.6,
        maxInputVolatge: 370,
        startUpVoltage: 125,
        operatingVoltage: 425,
        mppt: 26,
        mscc: 34,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 9.6,
        dataSheet1: "../images/Inverter/Inverex/8kWHybrid-1.jpg",
        dataSheet2: "../images/Inverter/Inverex/8kWHybrid-2.jpg",
      },
    ],
    powerSensor: ["No Power Sensor", "Power Sensor"],
    communicationDevice: [
      "No Communication Device",
      // "SM Stick logger LSW-3-C(DB9)",
      // "SM Stick logger LSW-3-C(USB)",
      // "SM Stick logger LSW-5 (USB)",
      // "SM Stick logger LS4G-5 (DB9)",
    ],
  },

  {
    brand: "FOX",
    phase: "Three Phase",
    systemType: "On Grid",
    inverterType: [
      {
        name: "Fox G3 T3",
        value: 3,
        outPutPower: 3000,
        pvPower: 3600,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 140,
        operatingVoltage: 1000,
        mppt: 14,
        mscc: 18.2,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 4.8,
        dataSheet1: "../images/Inverter/Fox/3-25TG31.png",
        dataSheet2: "../images/Inverter/Fox/3-25TG32.png",
      },
      {
        name: "Fox G3 T4",
        value: 4,
        outPutPower: 4000,
        pvPower: 4800,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 140,
        operatingVoltage: 1000,
        mppt: 14,
        mscc: 18.2,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 6.4,
        dataSheet1: "../images/Inverter/Fox/3-25TG31.png",
        dataSheet2: "../images/Inverter/Fox/3-25TG32.png",
      },
      {
        name: "Fox G3 T5",
        value: 5,
        outPutPower: 5000,
        pvPower: 6000,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 140,
        operatingVoltage: 1000,
        mppt: 14,
        mscc: 18.2,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 8,
        dataSheet1: "../images/Inverter/Fox/3-25TG31.png",
        dataSheet2: "../images/Inverter/Fox/3-25TG32.png",
      },
      {
        name: "Fox G3 T6",
        value: 6,
        outPutPower: 6000,
        pvPower: 7200,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 140,
        operatingVoltage: 1000,
        mppt: 14,
        mscc: 18.2,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 9.6,
        dataSheet1: "../images/Inverter/Fox/3-25TG31.png",
        dataSheet2: "../images/Inverter/Fox/3-25TG32.png",
      },
      {
        name: "Fox G3 T8",
        value: 8,
        outPutPower: 8000,
        pvPower: 9600,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 140,
        operatingVoltage: 1000,
        mppt: 14,
        mscc: 18.2,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 12.8,
        dataSheet1: "../images/Inverter/Fox/3-25TG31.png",
        dataSheet2: "../images/Inverter/Fox/3-25TG32.png",
      },
      {
        name: "Fox G3 T10",
        value: 10,
        outPutPower: 10000,
        pvPower: 12000,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 140,
        operatingVoltage: 1000,
        mppt: 14,
        mscc: 18.2,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 15.9,
        dataSheet1: "../images/Inverter/Fox/3-25TG31.png",
        dataSheet2: "../images/Inverter/Fox/3-25TG32.png",
      },
      {
        name: "Fox G3 T12",
        value: 12,
        outPutPower: 12000,
        pvPower: 14400,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 140,
        operatingVoltage: 1000,
        mppt: 14,
        mscc: 18.2,
        noOfMPPT: 2,
        noOfStrings: 2,
        acCurrent: 19.1,
        dataSheet1: "../images/Inverter/Fox/3-25TG31.png",
        dataSheet2: "../images/Inverter/Fox/3-25TG32.png",
      },
      {
        name: "Fox G3 T15",
        value: 15,
        outPutPower: 15000,
        pvPower: 18000,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 140,
        operatingVoltage: 1000,
        mppt: 28,
        mscc: 36.4,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 23.9,
        dataSheet1: "../images/Inverter/Fox/3-25TG31.png",
        dataSheet2: "../images/Inverter/Fox/3-25TG32.png",
      },
      {
        name: "Fox G3 T17",
        value: 17,
        outPutPower: 17000,
        pvPower: 20400,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 140,
        operatingVoltage: 1000,
        mppt: 28,
        mscc: 36.4,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 27.1,
        dataSheet1: "../images/Inverter/Fox/3-25TG31.png",
        dataSheet2: "../images/Inverter/Fox/3-25TG32.png",
      },
      {
        name: "Fox G3 T20",
        value: 20,
        outPutPower: 20000,
        pvPower: 24000,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 140,
        operatingVoltage: 1000,
        mppt: 28,
        mscc: 36.4,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 31.9,
        dataSheet1: "../images/Inverter/Fox/3-25TG31.png",
        dataSheet2: "../images/Inverter/Fox/3-25TG32.png",
      },
      {
        name: "Fox G3 T23",
        value: 23,
        outPutPower: 23000,
        pvPower: 27600,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 140,
        operatingVoltage: 1000,
        mppt: 28,
        mscc: 36.4,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 36.7,
        dataSheet1: "../images/Inverter/Fox/3-25TG31.png",
        dataSheet2: "../images/Inverter/Fox/3-25TG32.png",
      },
      {
        name: "Fox G3 T25",
        value: 25,
        outPutPower: 25000,
        pvPower: 30000,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 140,
        operatingVoltage: 1000,
        mppt: 28,
        mscc: 36.4,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 39.9,
        dataSheet1: "../images/Inverter/Fox/3-25TG31.png",
        dataSheet2: "../images/Inverter/Fox/3-25TG32.png",
      },
      {
        name: "Fox G3 PRO T15",
        value: 15,
        outPutPower: 15000,
        pvPower: 18000,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 140,
        operatingVoltage: 600,
        mppt: 32,
        mscc: 41.6,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 23.9,
        dataSheet1: "../images/Inverter/Fox/15-25TGPRO1.png",
        dataSheet2: "../images/Inverter/Fox/15-25TGPRO2.png",
      },
      {
        name: "Fox G3 PRO T17",
        value: 17,
        outPutPower: 17000,
        pvPower: 20400,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 140,
        operatingVoltage: 600,
        mppt: 32,
        mscc: 41.6,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 27.1,
        dataSheet1: "../images/Inverter/Fox/15-25TGPRO1.png",
        dataSheet2: "../images/Inverter/Fox/15-25TGPRO2.png",
      },
      {
        name: "Fox G3 PRO T20",
        value: 20,
        outPutPower: 20000,
        pvPower: 24000,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 140,
        operatingVoltage: 600,
        mppt: 32,
        mscc: 41.6,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 31.9,
        dataSheet1: "../images/Inverter/Fox/15-25TGPRO1.png",
        dataSheet2: "../images/Inverter/Fox/15-25TGPRO2.png",
      },
      {
        name: "Fox G3 PRO T23",
        value: 23,
        outPutPower: 23000,
        pvPower: 27600,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 140,
        operatingVoltage: 600,
        mppt: 40,
        mscc: 52,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 36.7,
        dataSheet1: "../images/Inverter/Fox/15-25TGPRO1.png",
        dataSheet2: "../images/Inverter/Fox/15-25TGPRO2.png",
      },
      {
        name: "Fox G3 PRO T25",
        value: 25,
        outPutPower: 25000,
        pvPower: 30000,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 140,
        operatingVoltage: 600,
        mppt: 40,
        mscc: 52,
        noOfMPPT: 2,
        noOfStrings: 4,
        acCurrent: 39.9,
        dataSheet1: "../images/Inverter/Fox/15-25TGPRO1.png",
        dataSheet2: "../images/Inverter/Fox/15-25TGPRO2.png",
      },
      {
        name: "Fox R75",
        value: 75,
        outPutPower: 75000,
        pvPower: 90000,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 250,
        operatingVoltage: 850,
        mppt: 26,
        mscc: 40,
        noOfMPPT: 9,
        noOfStrings: 18,
        acCurrent: 119.6,
        dataSheet1: "../images/Inverter/Fox/75-110R1.png",
        dataSheet2: "../images/Inverter/Fox/75-110R2.png",
      },
      {
        name: "Fox R100",
        value: 100,
        outPutPower: 100000,
        pvPower: 120000,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 250,
        operatingVoltage: 850,
        mppt: 26,
        mscc: 40,
        noOfMPPT: 9,
        noOfStrings: 18,
        acCurrent: 166.7,
        dataSheet1: "../images/Inverter/Fox/75-110R1.png",
        dataSheet2: "../images/Inverter/Fox/75-110R2.png",
      },
      {
        name: "Fox R110",
        value: 110,
        outPutPower: 110000,
        pvPower: 132000,
        efficiency: 98.6,
        maxInputVolatge: 1100,
        startUpVoltage: 250,
        operatingVoltage: 850,
        mppt: 26,
        mscc: 40,
        noOfMPPT: 10,
        noOfStrings: 20,
        acCurrent: 175.3,
        dataSheet1: "../images/Inverter/Fox/75-110R1.png",
        dataSheet2: "../images/Inverter/Fox/75-110R2.png",
      },
    ],
    powerSensor: ["No Power Sensor", "Power Sensor"],
    communicationDevice: ["No Communication Device", "WiFi Stick"],
  },
];
